import {
  Button,
  CollaboratorList,
  ConfirmDialog,
  CreateDialog,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  DraggableTreeNode,
  DraggableTreeView,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  EmailAuthDialog,
  Input,
  Label,
  LinkedEmailsSection,
  MessageDialog,
  MoveDialog,
  ProfileDialog,
  ReorderDropZone,
  SimpleInputDialog,
  TreeNode,
  TreeView,
  buildActionNodeData,
  buttonVariants,
  cn,
  createBetterAuthClient,
  getBetterAuthClient,
  inputVariants
} from "./chunk-4QBTND5D.js";
import {
  normalizeError,
  useApiCall,
  useDoubleTap,
  useHashRouter,
  useHierarchy,
  usePWAInstall,
  useSharing,
  useSubscription,
  useTheme,
  useTreeState
} from "./chunk-DKKZANJJ.js";

// src/index.ts
import {
  CircularReferenceError,
  getOwner,
  ItemLimitExceededError,
  isIterable,
  isLoaded,
  iterateChildren,
  NamingConflictError,
  toArray,
  walkTree
} from "@jbr-jazz/hierarchy-shared";

// src/lib/dialog-context.tsx
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var DialogContext = createContext(null);
function DialogProvider({ children }) {
  const [dialog, setDialog] = useState(null);
  const close = useCallback(() => setDialog(null), []);
  const showAlert = useCallback((options) => {
    return new Promise((resolve) => {
      setDialog({ type: "alert", options, resolve });
    });
  }, []);
  const showConfirm = useCallback((options) => {
    return new Promise((resolve) => {
      setDialog({ type: "confirm", options, resolve });
    });
  }, []);
  const showInput = useCallback((options) => {
    return new Promise((resolve) => {
      setDialog({ type: "input", options, resolve });
    });
  }, []);
  const value = useMemo(
    () => ({ showAlert, showConfirm, showInput }),
    [showAlert, showConfirm, showInput]
  );
  return /* @__PURE__ */ jsxs(DialogContext.Provider, { value, children: [
    children,
    dialog?.type === "alert" && /* @__PURE__ */ jsx(
      MessageDialog,
      {
        open: true,
        title: dialog.options.title,
        message: dialog.options.message,
        confirmText: dialog.options.confirmText,
        onConfirm: () => {
          dialog.resolve();
          close();
        }
      }
    ),
    dialog?.type === "confirm" && /* @__PURE__ */ jsx(
      ConfirmDialog,
      {
        open: true,
        title: dialog.options.title,
        message: dialog.options.message,
        confirmText: dialog.options.confirmText,
        cancelText: dialog.options.cancelText,
        variant: dialog.options.variant,
        onConfirm: () => {
          dialog.resolve(true);
          close();
        },
        onCancel: () => {
          dialog.resolve(false);
          close();
        }
      }
    ),
    dialog?.type === "input" && /* @__PURE__ */ jsx(
      SimpleInputDialog,
      {
        open: true,
        title: dialog.options.title,
        description: dialog.options.description,
        inputLabel: dialog.options.inputLabel,
        defaultValue: dialog.options.defaultValue,
        placeholder: dialog.options.placeholder,
        confirmText: dialog.options.confirmText,
        cancelText: dialog.options.cancelText,
        required: dialog.options.required,
        onSubmit: (value2) => {
          dialog.resolve(value2);
          close();
        },
        onCancel: () => {
          dialog.resolve(null);
          close();
        }
      }
    )
  ] });
}
function useDialog() {
  const ctx = useContext(DialogContext);
  if (!ctx) throw new Error("useDialog must be used within DialogProvider");
  return ctx;
}
export {
  Button,
  CircularReferenceError,
  CollaboratorList,
  ConfirmDialog,
  CreateDialog,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogProvider,
  DialogTitle,
  DialogTrigger,
  DraggableTreeNode,
  DraggableTreeView,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  EmailAuthDialog,
  Input,
  ItemLimitExceededError,
  Label,
  LinkedEmailsSection,
  MessageDialog,
  MoveDialog,
  NamingConflictError,
  ProfileDialog,
  ReorderDropZone,
  SimpleInputDialog,
  TreeNode,
  TreeView,
  buildActionNodeData,
  buttonVariants,
  cn,
  createBetterAuthClient,
  getBetterAuthClient,
  getOwner,
  inputVariants,
  isIterable,
  isLoaded,
  iterateChildren,
  normalizeError,
  toArray,
  useApiCall,
  useDialog,
  useDoubleTap,
  useHashRouter,
  useHierarchy,
  usePWAInstall,
  useSharing,
  useSubscription,
  useTheme,
  useTreeState,
  walkTree
};
